// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2uak3","sendOtp":"AuthorizeToLogin_sendOtp__1xu57"};